import type { Course } from 'src/v3/core/types'

export interface CourseRow {
  id: string
  name: string
  length: number
  category: string
  categoryID: string
}

export function transformCoursesToRows(courses: Course[]): CourseRow[] {
  return courses.map((course) => ({
    id: course.id,
    name: course.name,
    length: course.length || 0,
    category: course.section || 'Uncategorized',
    categoryID: course.sectionID,
  }))
}

export function extractCategories(courseRows: CourseRow[]): string[] {
  let categoriesSet = new Set<string>()
  courseRows.forEach((course) => categoriesSet.add(course.category))
  return Array.from(categoriesSet).toSorted((a, b) => a.localeCompare(b))
}

export function filterCourses(
  courses: CourseRow[],
  selectedCourses: string[],
  categoryFilter: string,
  searchQuery: string,
): CourseRow[] {
  let query = searchQuery.toLowerCase()
  let selectedSet = new Set(selectedCourses)

  return courses.filter((course) => {
    // Always include selected courses
    if (selectedSet.has(course.id)) return true

    // Apply filters to non-selected courses
    if (categoryFilter && course.category !== categoryFilter) return false
    if (searchQuery && !course.name.toLowerCase().includes(query)) return false
    return true
  })
}
